<template>
  <div class="page-scroll" @scroll="bindScroll" ref="container">
    <div class="page-content">
      <ReportItem
        :id="'scroll-' + index + '-' + index1"
        v-for="(item1, index1) in data.data"
        :key="index1"
        :data="item1"
        :type="data.type"
      />
      <div class="fixed-bottom">
        <van-tabs class="bottom-bar" v-model="active" @change="bindChange">
          <van-tab
            v-for="(item, index) in data.data"
            :key="index"
            :title="typeData[item.chartGroup]"
          ></van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import ReportItem from './item.vue'
export default {
  components: {
    ReportItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      typeData: {
        appSummary: 'APP',
        convertSummary: '转化',
        followEatSummary: '跟吃',
        positionSummary: '金刚位'
      },
      active: 0
    }
  },
  methods: {
    bindChange() {
      let el = document.getElementById(
        'scroll-' + this.index + '-' + this.active
      )
      this.$refs.container.scrollTop = el.offsetTop
    },
    bindScroll(e) {
      let scrollTop = e.target.scrollTop
      let curIndex = this.data.data.length - 1
      for (let i = 0; i < this.data.data.length; i++) {
        let el = document.getElementById('scroll-' + this.index + '-' + i)
        let offset = el.offsetTop + el.clientHeight
        if (scrollTop < offset) {
          curIndex = i
          break
        }
      }
      this.active = curIndex
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom-bar {
  ::v-deep .van-tabs__nav {
    background: rgb(45, 122, 252);
  }
  ::v-deep .van-tab {
    color: rgba(255, 255, 255, 0.8);
  }
  ::v-deep .van-tab--active {
    font-size: 16px;
    color: #fff;
  }
  ::v-deep .van-tabs__line {
    width: 80px;
    background: #f48924;
  }
}

.page-scroll {
  height: 100%;
  overflow-y: scroll;
}
.page-content {
  position: relative;
  @include paddingBottom(40px);
}

.fixed-bottom {
  position: fixed;
  z-index: 9999999;
  width: 100%;
  left: 0;
  bottom: 0;
  background: rgb(45, 122, 252);
  @include paddingBottom();
}
</style>
